var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 10H11.08C8.863 10.002 6.852 10.833 5.34 12.347C3.828 13.857 3 15.867 3.004 18.002L11 17.998C11 18 45 18 45 18V45H11V24H3V76C3 81.514 7.486 86 13 86H83C88.514 86 93 81.514 93 76V20C93 14.486 88.514 10 83 10ZM11 76V51H45V78H13C11.897 78 11 77.103 11 76ZM83 78H51V18H83C84.103 18 85 18.897 85 20V45H57V51H85V76C85 77.103 84.103 78 83 78ZM22.814 38.46V25.376C22.814 24.604 23.65 24.121 24.319 24.507L35.65 31.049C36.319 31.435 36.319 32.4 35.65 32.786L24.319 39.328C23.649 39.715 22.814 39.232 22.814 38.46ZM35.562 64.958L24.398 71.404C23.729 71.79 22.893 71.308 22.893 70.535V57.644C22.893 56.872 23.729 56.389 24.398 56.775L35.562 63.221C36.231 63.607 36.231 64.572 35.562 64.958ZM61.815 38.364V25.472C61.815 24.7 62.651 24.217 63.32 24.603L74.484 31.049C75.153 31.435 75.153 32.4 74.484 32.786L63.32 39.232C62.651 39.619 61.815 39.136 61.815 38.364ZM74.484 64.958L63.32 71.404C62.651 71.79 61.815 71.308 61.815 70.535V57.644C61.815 56.872 62.651 56.389 63.32 56.775L74.484 63.221C75.153 63.607 75.153 64.572 74.484 64.958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMonitoring);
export default __webpack_public_path__ + "static/media/ico-monitoring.b722dae87014f70abf9286bc713c528d.svg";
export { ForwardRef as ReactComponent };